module.exports = __webpack_public_path__ + "img/10_74.5be4f756.png";